import React from 'react';
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/skeleton';

export interface InspectorLoadingProps {
  className?: string;
}

export const InspectorLoading: React.FC<InspectorLoadingProps> = ({ className = '' }) => {
  return (
    <div
      className={clsx(
        'inspector bg-neutral-0 relative z-10 inline-flex h-[calc(100vh-52px)] w-full max-w-[240px] flex-col border-l border-neutral-100',
        className,
      )}
    >
      <div className="inline-flex flex-col items-center justify-center gap-3 self-stretch px-3 pt-3 pb-6">
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-48 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    </div>
  );
};

export default InspectorLoading;
